<template>
    <v-app>
      <app-header :auth="ProviderAuth" v-if="showAppBar"></app-header>
      <v-main>
        <v-container fluid class="pa-0">
          <router-view :auth="ProviderAuth"></router-view>
          <app-toast></app-toast>
        </v-container>
      </v-main>
      <app-bottom></app-bottom>
    </v-app>
</template>

<script>

import Header from '@/components/Header'
import Bottom from '@/components/Bottom'
import Toast from '@/components/Toast'
import { ProviderAuth, Controls } from '@/gql'
export default {
  name: 'app',
  components: {
    'app-header': Header,
    'app-bottom': Bottom,
    'app-toast': Toast
  },
  created() {
    document.title = "FilmID";
  },
  data: () => {
    return {
      ProviderAuth: {},
      Controls: {}
    }
  },
  computed: {
    showAppBar () {
      return this.Controls && this.Controls.showAppBar
    }
  },
  apollo: {
    ProviderAuth () {
      return {
        query: ProviderAuth
      }
    },
    Controls () {
      return {
        query: Controls
      }
    }
  }
}
</script>
